export const providerMainQueryKey = "providers";
